var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-autocomplete', _vm._g(_vm._b({
    attrs: {
      "value": _vm.value,
      "fetch-suggestions": _vm.getUenRemote,
      "loading": _vm.uenLoading,
      "clearable": ""
    },
    on: {
      "select": _vm.handleUenSelect,
      "blur": _vm.handleUenBlur,
      "focus": _vm.handleUenFocus
    }
  }, 'el-autocomplete', _vm.$attrs, false), _vm.listeners));
}
var staticRenderFns = []

export { render, staticRenderFns }